import React from 'react';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { Td, Th } from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';

const ProductCatalogInternet = ({ tableData = {} }) => {
  const { data = [], monthlyCharges = 0, oneTimeCharges = 0 } = tableData;

  if (data.length === 0) return null;
  const locale = getLocale();
  const {
    vulcanWebform: {
      offerCode,
      offerDescription,
      offerDetails,
      monthlyChargesColumn,
      oneTimeChargeColumn
    }
  } = locale === 'en-US' ? EN : FR;
  return (
    <>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '20px'
        }}
      >
        <thead>
          <tr style={{ height: '60px' }}>
            <Th>{offerCode}</Th>
            {/* <Th>{offerDescription}</Th> */}
            <Th>{offerDetails}</Th>
            <Th>{monthlyChargesColumn}</Th>
            <Th>{oneTimeChargeColumn}</Th>
          </tr>
        </thead>
        <tbody>
          {data.map((field, index) => {
            const details = field.offerDetails;
            const rowSpan = details.length; // always >= 1

            return details.map((detail, detailIndex) => (
              <tr>
                {detailIndex === 0 && (
                  <>
                    <Td rowSpan={rowSpan}>{field.offerCode}</Td>
                    {/* <Td rowSpan={rowSpan}>
                      {locale === 'en-US'
                        ? field.descriptionEn
                        : field.descriptionFr}
                    </Td> */}
                  </>
                )}

                {/* One row per offer detail */}
                <Td>{detail.offerDetailsEn}</Td>
                <Td>
                  {detail.frequency === 'monthly'
                    ? formatCurrency(detail.value)
                    : formatCurrency(0)}
                </Td>
                <Td>
                  {detail.frequency === 'oneTime'
                    ? formatCurrency(detail.value)
                    : formatCurrency(0)}
                </Td>
              </tr>
            ));
          })}
          <tr>
            <Td bold textAlign="center" colSpan={2}>
              Total Charges
            </Td>
            <Td bold>{formatCurrency(monthlyCharges)}</Td>
            <Td bold>{formatCurrency(oneTimeCharges)}</Td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ProductCatalogInternet;
